import { createApp } from "vue";
import App from "./App.vue";
import { createI18n } from "vue-i18n";
import { en, zhHans, zhHant } from "../locale/index.js";
import "./styles/variety-font/index.js";
import { setStorage } from "@/utils/storage";
import { countryToLanguage, countryToCountry } from "@/utils/common.js";
import Antd from "ant-design-vue";
import Vconsole from "vconsole";
import "ant-design-vue/dist/reset.css";
import Cookies from "js-cookie";
import init from "@/utils/hybrid/init";
import { isPopApp } from "@/utils/hybrid";
import "@/utils/flexiable.js";

if (isPopApp()) {
  init();
}

const messages = {
  en,
  "zh-hans": zhHans,
  "zh-hant": zhHant,
};
const { pathname, origin, hash } = window.location;
const country = pathname.replaceAll("/", "") || "us";

// pathname转为小写后重新刷新下页面
const currentPathname = pathname;
const lowerCasePathname = currentPathname.toLowerCase();
// 如果当前pathname包含大写字母，则重定向到小写版本
if (currentPathname !== lowerCasePathname) {
  const newUrl = origin + lowerCasePathname + hash;
  window.location.replace(newUrl);
}

let i18nConfig = {
  legacy: false, // you must set `false`, to use Composition API
  locale: countryToLanguage(country), //这里是设置你vue页面中要使用哪种语言,获取已设置的语言 uni-getLocale()
  messages,
};
const i18n = createI18n(i18nConfig);

setStorage("LANGUAGE", i18nConfig.locale);
setStorage("countryStorage", countryToCountry(country || "us"));

const app = createApp(App);

if (process.env.DEFINE_NODE_ENV !== "prod") {
  const vConsole = new Vconsole();
  app.use(vConsole);
}
app.use(i18n);
app.use(Antd);
app.mount("#app");
